<form [formGroup]="form">
  <table>
    <tbody class="inner">
      <tr>
        <td>&nbsp;</td>
        <td>
          @if (!newRow) {
            <span>{{selected.MCPGroup}}<br /></span>
          }
          <input type="text" id="Title"
            formControlName="Title" required
            placeholder="enter the title..."
            title="{{header[TITLE].label}}"
            [ngClass]="classname[TITLE]"
            (change)="onTitleChange()"
            class="form-control" />
            @if (!newRow) {
              <button type="button" class="btn btn-default" title="Undo changes" [disabled]="isundodisabled[TITLE] == true" (click)="onTitleUndo()">
                <span class='glyphicon glyphicon-arrow-left'></span>
              </button>
            }
            <br />
          </td>
          <td>
            @if (!newRow) {
              <span>{{selected.IsLobby}}<br /></span>
            }
            <input id="Lobby"
              type="checkbox"
              formControlName="Lobby"
              title="{{header[ISLOBBY].label}}"
              [ngClass]="classname[ISLOBBY]"
              (change)="onIsLobbyChange()"
              class="form-control" />
              @if (!newRow) {
                <button type="button" class="btn btn-default" title="Undo changes" [disabled]="isundodisabled[ISLOBBY] == true" (click)="onIsLobbyUndo()">
                  <span class='glyphicon glyphicon-arrow-left'></span>
                </button>
              }
            </td>
            <td>
              <button type="button"
                class="btn btn-warning"
                (click)="onRowCancel()">
                Cancel
              </button>
            </td>

          </tr>
        </tbody>
      </table>
    </form>